<template>
  <filtertron-tray-section
    v-if="category.createdAt"
    id="category-configurator-judging"
    :title="lang.get('category.configuration.judging.label')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <p>
        {{ lang.get('category.form.judging.attachments.description') }}
      </p>
      <attachment-types
        v-for="scoreSet in scoreSets"
        :key="'attachment-types-' + scoreSet.id"
        :category="category"
        :score-set="scoreSet"
        :attachment-types="attachmentTypes[scoreSet.id]"
        @input="types => handleInput('attachmentTypes', types)"
      />
    </div>
  </filtertron-tray-section>
</template>

<script>
import { mapState } from 'vuex';
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import handleInputMixin from '../handle-input-mixin.js';
import AttachmentTypes from './AttachmentTypes';

export default {
  inject: ['lang'],
  components: {
    FiltertronTraySection,
    AttachmentTypes
  },
  mixins: [handleInputMixin],
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('entryForm', ['scoreSets', 'attachmentTypes'])
  }
};
</script>
